import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { ShipmentAuditLog } from '../../types';

export interface GetShipmentAuditLogsRequestParams {
  shipmentkey: number;
  ModuleId: number;
}

export const getShipmentAuditLogsAPI = (params: GetShipmentAuditLogsRequestParams) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetAuditLogData`,
    method: 'get',
    params,
  });
};

export type ShipmentAuditLogsResponse = ShipmentAuditLog[];

export const fetchShipmentAuditLogs = async (
  params: GetShipmentAuditLogsRequestParams,
): Promise<ShipmentAuditLogsResponse> => {
  const response: AxiosResponse<ShipmentAuditLogsResponse> = await getShipmentAuditLogsAPI(params);
  return response.data;
};
